<app-loader></app-loader>
<div class="vehicle-model custom-vehicle-model">
  <form [formGroup]="vehicleForm" (ngSubmit)="isEditForm ? onEdit() : saveAndSelect()">
    <div class="model-heading">
      <div *ngIf="comingFrom === 'createBookingSection' ">
        <div class="filter-inner mt-0 equipment-outer">
          <h4 class="custom-label">{{spotTypeMsg}}</h4>
          <span class="custom-div">|</span>
          <div class="custom-select2">
            <div class="custom-dropdown">
              <p-dropdown formControlName="vehicleType" [options]="truckType" name="vehicleType" optionLabel="name"
                [disabled]="true" [readonly]="true">
                <ng-template let-item pTemplate="item">
                  <div style="display: flex; align-items: center;">
                    <img [src]="item.vehicleTypeImagePath" width="50" height="50" style="vertical-align: middle;" alt="">
                    <span style="margin-left: 10px;">{{item.name}}</span>
                  </div>
                </ng-template>
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="comingFrom !== 'createBookingSection' ">
        <div class="filter-inner mt-0 equipment-outer">
          <h4 class="custom-label truck-type">{{spotTypeMsg}}</h4>
          <span class="custom-div">|</span>
          <div class="equipment-type">
          <div class="custom-select2 choose-dropdown">
            <div class="custom-dropdown">
              <p-dropdown #dropdown formControlName="vehicleType" (onChange)="onTruckTypeChange($event)" [options]="truckTypes"
                name="vehicleType" placeholder="Choose Spot" optionLabel="name">
                <ng-template let-item pTemplate="item">
                  <div style="display: flex; align-items: center;">
                    <img [src]="item.vehicleTypeImagePath" width="50" height="50" style="vertical-align: middle;" alt="">
                    <span style="margin-left: 10px;">{{item.name}}</span>
                  </div>
                </ng-template>
              </p-dropdown>
              <img (click)="openDropdown()" src="assets/images/fill-dropdown.svg" alt=""/>
            </div>
          </div>
          <div>
            <app-tooltip *ngIf="vehicleForm.get('vehicleType').value"  [addClass]="'custom-tooltip-width'" [tooltipMessage]="EquipmentDescription"></app-tooltip>
          </div>
        </div>
        </div>
      </div>
      <img src="../../../../../assets/images/model-close.svg" (click)="cancelDialog()" alt="Close"/>
    </div>
    <div class="form-inner">
      <div class="grid">
        <div class="col-12 md:col-5 xl:col-5">
          <div class="upload-outerbox">
            <div class="custom-lightbg custom-upload-field">
              <div class="light-bg">
                <div class="uploadImageOuter cstom-manager">
                  <div class="uploaded-imgbox">
                    <img [src]="(imageUrl ? imageUrl: dummy)" alt="Preview" *ngIf="!isLoading"
                      class="preview-image img-fluid">
                    <p-progressSpinner *ngIf="isLoading"></p-progressSpinner>
                  </div>
                  <div class="upload-btn-wrapper">
                    <button class="btn">
                      <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M13.3593 4.21225C13.1162 3.24046 12.5554 2.37774 11.7659 1.76108C10.9765 1.14443 10.0037 0.8092 9.00192 0.808619C8.00017 0.808037 7.02695 1.14214 6.23678 1.75787C5.44662 2.37361 4.88481 3.23568 4.64057 4.20719C3.48847 4.31531 2.4223 4.86309 1.66353 5.73675C0.904755 6.61041 0.511696 7.74278 0.565997 8.89867C0.620298 10.0546 1.11778 11.1451 1.95512 11.9438C2.79246 12.7424 3.90528 13.1879 5.06244 13.1875H6.74994C6.89912 13.1875 7.0422 13.1282 7.14769 13.0227C7.25318 12.9173 7.31244 12.7742 7.31244 12.625C7.31244 12.4758 7.25318 12.3327 7.14769 12.2273C7.0422 12.1218 6.89912 12.0625 6.74994 12.0625H5.06244C4.61923 12.0638 4.1801 11.9778 3.77013 11.8094C3.36017 11.6409 2.98738 11.3934 2.67307 11.0809C2.03829 10.4499 1.68021 9.59245 1.6776 8.69734C1.67499 7.80224 2.02806 6.94276 2.65915 6.30798C3.29024 5.67319 4.14765 5.31511 5.04275 5.3125C5.18709 5.32337 5.33031 5.28023 5.44464 5.19147C5.55897 5.10271 5.63625 4.97465 5.6615 4.83213C5.77604 4.02891 6.17652 3.29398 6.78938 2.76231C7.40225 2.23064 8.18635 1.93793 8.99769 1.93793C9.80903 1.93793 10.5931 2.23064 11.206 2.76231C11.8189 3.29398 12.2193 4.02891 12.3339 4.83213C12.3633 4.9697 12.4396 5.09279 12.5496 5.1804C12.6597 5.26801 12.7968 5.3147 12.9374 5.3125C13.8325 5.3125 14.691 5.66808 15.3239 6.30101C15.9569 6.93395 16.3124 7.79239 16.3124 8.6875C16.3124 9.58261 15.9569 10.4411 15.3239 11.074C14.691 11.7069 13.8325 12.0625 12.9374 12.0625H11.2499C11.1008 12.0625 10.9577 12.1218 10.8522 12.2273C10.7467 12.3327 10.6874 12.4758 10.6874 12.625C10.6874 12.7742 10.7467 12.9173 10.8522 13.0227C10.9577 13.1282 11.1008 13.1875 11.2499 13.1875H12.9374C14.0861 13.1755 15.1867 12.7246 16.0137 11.9273C16.8407 11.1299 17.3314 10.0465 17.3854 8.89903C17.4393 7.75154 17.0524 6.62687 16.3038 5.75548C15.5553 4.88409 14.5018 4.33197 13.3593 4.21225Z"
                          fill="white" />
                        <path
                          d="M11.4145 9.08524C11.5206 9.18771 11.6627 9.2444 11.8102 9.24312C11.9577 9.24184 12.0988 9.18268 12.2031 9.07839C12.3074 8.9741 12.3665 8.83302 12.3678 8.68553C12.3691 8.53804 12.3124 8.39596 12.2099 8.28987L9.39742 5.47737C9.29194 5.37191 9.14889 5.31267 8.99974 5.31267C8.85058 5.31267 8.70753 5.37191 8.60205 5.47737L5.78955 8.28987C5.68708 8.39596 5.63039 8.53804 5.63167 8.68553C5.63295 8.83302 5.69211 8.9741 5.7964 9.07839C5.90069 9.18268 6.04177 9.24184 6.18926 9.24312C6.33675 9.2444 6.47883 9.18771 6.58492 9.08524L8.43724 7.23293V14.3126C8.43724 14.4617 8.4965 14.6048 8.60199 14.7103C8.70748 14.8158 8.85055 14.8751 8.99974 14.8751C9.14892 14.8751 9.29199 14.8158 9.39748 14.7103C9.50297 14.6048 9.56224 14.4617 9.56224 14.3126V7.23293L11.4145 9.08524Z"
                          fill="white" />
                      </svg>
                    </button>
                    <input type="file" name="myfile" (change)="onImageSelected($event)" accept="image/*"
                      id="imageInput" />
                  </div>
                  <div *ngIf="imageUrl" class="upload-btn-wrapper"><button class="btn" (click)="clearImage()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M2 3.5H3.33333L15 3.5" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M5.35714 3.5V2C5.35714 1.60218 5.5227 1.22064 5.8174 0.93934C6.1121 0.658035 6.5118 0.5 6.92857 0.5H10.0714C10.4882 0.5 10.8879 0.658035 11.1826 0.93934C11.4773 1.22064 11.6429 1.60218 11.6429 2V3.5M14 3.5V14C14 14.3978 13.8344 14.7794 13.5397 15.0607C13.245 15.342 12.8453 15.5 12.4286 15.5H4.57143C4.15466 15.5 3.75496 15.342 3.46026 15.0607C3.16556 14.7794 3 14.3978 3 14V3.5H14Z"
                          stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9.33333 7.33333V11.3333" stroke="white" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M6.66667 7.33333V11.3333" stroke="white" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                    </button></div>
                  <div *ngIf="isProfileImgError">
                    <div class="validation-error">File size should be less than 5MB.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 md:col-7 xl:col-7">
          <div class="input-fields">
            <div class="grid">

              <div class="col-12 md:col-6 xl:col-6">
                <div class="filter-inner mt-0">
                  <h4 class="custom-label">
                    License Plate Number<span class="custom-star">*</span>
                  </h4>
                  <div class="custom-select2">
                    <div class="custom-input">
                      <input
                        type="text"
                        formControlName="licenseNumberPlate"
                        maxlength="15"
                        placeholder="Enter license number"
                        oninput="this.value = this.value.toUpperCase()"
                        name="licenseNumberPlate"
                        pInputText
                      />
                    </div>

<div *ngIf="vehicleForm.get('licenseNumberPlate').touched">
                      <div *ngIf="vehicleForm.get('licenseNumberPlate').hasError('required'); else patternError">
                        <div class="validation-error">This field is required*</div>
                      </div>

                      <ng-template #patternError>
                        <div *ngIf="vehicleForm.get('licenseNumberPlate').hasError('pattern'); else maxLengthError">
                          <div class="validation-error">License Plate Number is invalid.</div>
                        </div>
                      </ng-template>

                      <ng-template #maxLengthError>
                        <div *ngIf="vehicleForm.get('licenseNumberPlate').hasError('maxlength'); else minLengthError">
                          <div class="validation-error">Max. 15 characters are required.</div>
                        </div>
                      </ng-template>

                      <ng-template #minLengthError>
                        <div *ngIf="vehicleForm.get('licenseNumberPlate').hasError('minlength')">
                          <div class="validation-error">Min. 5 characters are required.</div>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 md:col-6 xl:col-6">
                <div class="filter-inner">
                  <div class="info-outer info-icon additional-lp">
                    <h4 class="custom-label">DOT Number</h4>
                    </div>

                  <div class="custom-select2">
                    <div class="custom-input">
                      <input type="text" formControlName="dotNumber" placeholder="Enter DOT number" maxlength="12"
                        minlength="6" name="dotNumber" oninput="this.value = this.value.toUpperCase()"
                        pattern="^[A-Za-z0-9]+$" pInputText />
                    </div>
                    <div *ngIf="vehicleForm.get('dotNumber').touched">
                      <div *ngIf="vehicleForm.get('dotNumber').hasError('pattern')">
                        <div class="validation-error">Dot Number is invalid.</div>
                      </div>
                      <div
                        *ngIf="vehicleForm.get('dotNumber').hasError('maxlength') && !vehicleForm.get('dotNumber').hasError('pattern')">
                        <div class="validation-error">Max. 12 digits are required.</div>
                      </div>
                      <div
                        *ngIf="vehicleForm.get('dotNumber').hasError('minlength') && !vehicleForm.get('dotNumber').hasError('pattern')">
                        <div class="validation-error">Min. 6 digits are required.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 md:col-6 xl:col-6">
                <div class="filter-inner">
                  <div class="info-outer info-icon additional-lp">
                    <h4 class="custom-label">Trailer Number</h4>
                    </div>

                  <div class="custom-select2">
                    <div class="custom-input">
                      <input type="text" formControlName="trailerNumber" placeholder="Enter Trailer Number" maxlength="12"
                        minlength="3" name="trailerNumber" oninput="this.value = this.value.toUpperCase()"
                         pInputText />
                    </div>
                    <div *ngIf="vehicleForm.get('trailerNumber').touched">

                      <div *ngIf="vehicleForm.get('trailerNumber').hasError('pattern')">
                        <div class="validation-error">Trailer Number is invalid.</div>
                      </div>
                      <div
                        *ngIf="vehicleForm.get('trailerNumber').hasError('minlength') && !vehicleForm.get('trailerNumber').hasError('pattern')">
                        <div class="validation-error">Min. 3 characters are required.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 md:col-6 xl:col-6">
                <div class="filter-inner">
                  <div class="info-outer info-icon additional-lp">
                    <h4 class="custom-label">Company Name</h4>
                  </div>

                  <div class="custom-select2">
                    <div class="custom-input">
                      <input type="text" formControlName="companyName" (keydown)="preventFirstSpace($event)" placeholder="Enter Company Name" maxlength="50" minlength="3"
                        name="companyName" pInputText />
                    </div>
                    <div
                      *ngIf="vehicleForm.get('companyName').hasError('minlength') && !vehicleForm.get('companyName').hasError('pattern')">
                      <div class="validation-error">Min. 3 characters are required.</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 md:col-6 xl:col-6">
                <div class="filter-inner">
                  <h4 class="custom-label">Make<span class="custom-star">*</span></h4>
                  <div class="custom-select2">
                    <div class="custom-dropdown">
                      <p-dropdown [options]="makes" formControlName="make" placeholder="Select a make"
                        optionLabel="name" optionValue="name" appendTo="body"></p-dropdown>
                      <img src="assets/images/fill-dropdown.svg" alt=""/>
                    </div>
                    <div *ngIf="vehicleForm.get('make').touched">
                      <div *ngIf="vehicleForm.get('make').hasError('required')">
                        <div class="validation-error">This field is required*</div>
                      </div>
                      <div *ngIf="vehicleForm.get('make').hasError('minlength') && !vehicleForm.get('make').hasError('pattern')">
                        <div class="validation-error">Min. 3 characters are required.</div>
                      </div>
                    </div>
                    </div>
                </div>
              </div>

              <div class="col-12 md:col-6 xl:col-6">
                <div class="filter-inner mt-0">
                  <h4 class="custom-label">Color<span class="custom-star">*</span></h4>
                  <div class="custom-select2">
                    <div class="custom-dropdown">
                      <p-dropdown [options]="colors" formControlName="color" placeholder="Select a color"
                        appendTo="body"></p-dropdown>
                      <img src="assets/images/fill-dropdown.svg" alt="" />
                    </div>
                    <div *ngIf="vehicleForm.get('color').touched">
                      <div *ngIf="vehicleForm.get('color').hasError('required')">
                        <div class="validation-error">This field is required*</div>
                      </div>
                      <div *ngIf="vehicleForm.get('color').hasError('minlength') && !vehicleForm.get('color').hasError('pattern')">
                        <div class="validation-error">Min. 3 characters are required.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="save-outer">
              <p-button type="submit" *ngIf="!isEditForm; else editLabel" label="Save & Select"></p-button>
              <ng-template #editLabel>
                <p-button type="submit" label="Update"></p-button>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="custom-export"> <p-menu #menu [model]="items" [popup]="true"></p-menu>
